export default __webpack_public_path__ + "static/media/profile.64ab8587.svg";